import { auth } from "../firebase";
import axios from "axios";

export async function getLastChatGames(num = 5) {
  try {
    const idToken = await auth.currentUser.getIdToken();
    const response = await axios.get(
      `https://api.solplay.me/admin/lastbets?num=${num}`,
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Errore durante il recupero delle ultime scommesse:", error);
    return [];
  }
}

export async function getStatsChatGames() {
  try {
    const idToken = await auth.currentUser.getIdToken();
    const response = await axios.get(`https://api.solplay.me/admin/totstat`, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Errore durante il recupero delle ultime scommesse:", error);
    return [];
  }
}

export async function getBestGamesChatGames() {
  try {
    const idToken = await auth.currentUser.getIdToken();
    const response = await axios.get(`https://api.solplay.me/admin/bestgames`, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Errore durante il recupero delle ultime scommesse:", error);
    return [];
  }
}

export async function getBestPlayersChatGames() {
  try {
    const idToken = await auth.currentUser.getIdToken();
    const response = await axios.get(`https://api.solplay.me/admin/bestusers`, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Errore durante il recupero delle ultime scommesse:", error);
    return [];
  }
}
